import React from "react";
import { NavLink } from "react-router-dom";

/**
 * Navigation Item Component
 * Renders a single navigation link with icon, label, tooltip, and badge
 * Supports both collapsed and expanded states
 */
const NavItem = ({ item, hoveredItem, setHoveredItem, isCollapsed }) => {
  return (
    <li className="relative group">
      <NavLink
        to={item.to}
        end={item.to === "/admin"}
        onMouseEnter={() => setHoveredItem(item.label)}
        onMouseLeave={() => setHoveredItem(null)}
        className={({ isActive }) =>
          `flex items-center ${
            isCollapsed ? "justify-center" : "justify-start px-4"
          } h-12 rounded-xl transition-all duration-200 relative group ${
            isActive
              ? "bg-white text-[#0f3460] shadow-lg font-medium"
              : "text-white/90 hover:bg-white/15 hover:text-white hover:shadow-md"
          }`
        }
      >
        <item.icon className="text-2xl flex-shrink-0" />

        {/* Label - Only visible when expanded */}
        {!isCollapsed && (
          <span className="ml-3 text-sm font-medium whitespace-nowrap">
            {item.label}
          </span>
        )}

        {/* Badge */}
        {item.badge && (
          <span
            className={`${
              isCollapsed ? "absolute -top-1 -right-1" : "ml-auto"
            } bg-red-500 text-white text-[9px] px-1.5 py-0.5 rounded-full font-semibold`}
          >
            {item.badge}
          </span>
        )}
      </NavLink>

      {/* Tooltip - Only show when collapsed */}
      {isCollapsed && (
        <div
          className={`fixed bg-gray-900 text-white text-xs px-3 py-2 rounded-lg whitespace-nowrap pointer-events-none transition-all duration-200 shadow-xl ${
            hoveredItem === item.label ? "opacity-100" : "opacity-0"
          }`}
          style={{
            zIndex: 99999,
            left: "92px", // Position just outside the 80px collapsed sidebar
            top: "var(--tooltip-top, 50%)",
            transform: "translateY(-50%)",
          }}
          ref={(el) => {
            if (el && hoveredItem === item.label) {
              const button = el.previousElementSibling;
              if (button) {
                const rect = button.getBoundingClientRect();
                el.style.setProperty(
                  "--tooltip-top",
                  `${rect.top + rect.height / 2}px`
                );
              }
            }
          }}
        >
          {item.label}
          {item.badge && (
            <span className="ml-2 bg-red-500 text-white text-[9px] px-1.5 py-0.5 rounded-full font-semibold">
              {item.badge}
            </span>
          )}
          <div className="absolute right-full top-1/2 -translate-y-1/2 border-4 border-transparent border-r-gray-900"></div>
        </div>
      )}
    </li>
  );
};

export default NavItem;
